import ErrorStackParser from "error-stack-parser";
import Modal from "root/Modals/VanillaModal/VanillaModal";
import $ from "jquery";
import he from 'he'
import {encode, decode} from 'js-base64';

import "root/Modals/VanillaModal/Modal.scss" ;

export const encodeStringForPost = (string) =>
{
    return string === null ? null : he.encode(encode(string));
}

export const decodeStringForPost = (decodeVal) =>
{
    return decodeVal === null ? null : decode(decodeVal);
}

export const getDataWithPromise = (url, type, data, suppressErrorCheck) =>
{
    return new Promise((resolve, reject) =>
    {
        if (url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            $.ajax(
                {
                    type: type,
                    url: url,
                    data: data,
                    success: (data) =>
                    {
                        if (suppressErrorCheck === true)
                        {
                            // Return a silent error if required
                            resolve(data);
                        }
                        else if (checkError(data))
                        {
                            resolve(data);
                        }
                    },
                    error: (jqXHR, textStatus, error) =>
                    {
                        reject(jqXHR, textStatus, error);
                    }
                });
        }
    });
}

export const getDataFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        return response.data;
    }
    else
    {
        return [];
    }
}

export const getCustomDataFromResponse = ( response ) =>
{
    if ( response.custom_data !== undefined && response.custom_data!= null )
    {
        return response.custom_data ;
    }
    else
    {
        return  null ;
    }
}

export const responseHasCustomData = ( response ) =>
{
    if ( response.custom_data !== undefined && response.custom_data!= null )
    {
        return true;
    }
    else
    {
        return false ;
    }
}

export const getNamedCustomDataFromResponse = (response, itemName) =>
{
    if (response.status !== undefined && response.status != null)
    {
        if ( response.custom_data !== undefined )
        {
            if ( response.custom_data[itemName] !== undefined )
            {
                return response.custom_data[itemName] ;
            }
            else
            {
                return [] ;
            }
        }
        else
        {
            return [] ;
        }
    }
    else
    {
        return [];
    }
}

export const getInsertIdFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        if (response.status.insertId !== undefined)
        {
            return response.status.insertId;
        }
        else
        {
            return null
        }
    }
    else
    {
        return null;
    }
}

export const getNumRowsFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        return +response.status.rowsAffected;
    }
    else
    {
        return 0;
    }
}

export const SUCCESS_STATUS = 'success';
export const FAIL_STATUS = 'fail';

export const getStatusFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        return response.status;
    }
    else
    {
        return null;
    }
}

export const getResultFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        return response.status.result;
    }
    else
    {
        return null;
    }
}

export const getErrorDetailromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        return response.status.errorDetail;
    }
    else
    {
        return null;
    }
}

export const getErrorFromResponse = (response) =>
{
    return response.status.error;
}

export const getExceptionClassFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        if ( response.status.exceptionClass !== undefined )
        {
            return response.status.exceptionClass;
        }
        else {
            return null ;
        }
    }
    else
    {
        return null;
    }
}

export const getStackTraceFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        if ( response.status.errorDetail.trace !== undefined )
        {
            return response.status.errorDetail.trace;
        }
        else {
            return null ;
        }
    }
    else
    {
        return null;
    }
}

export const getErrorDetailFromResponse = (response) =>
{
    return response.status.errorDetail;
}

export const responseHasStatusElement = (response) =>
{
    return response.status !== undefined;
}

//this is only used by the react register/activate form
export const checkError = (data) =>
{
    if (data != null)
    {
        if (responseHasStatusElement(data))
        {
            if (getResultFromResponse(data) === SUCCESS_STATUS)
            {
                return true;
            }
            else
            {
                console.error ( data ) ;

                let displayMessage = '';

                const type = getExceptionClassFromResponse(data)

                if ( type !== null )
                {
                    // This is a new type of error with exception type so we can make some more specific decisions

                    const stackTrace = getStackTraceFromResponse( data ) ;

                    if ( type.includes ( '\\APIAuthorisationException'))
                    {
                        // We need to inspect the stack to see where the error actually occurred

                        let callingFunctionDetails = stackTrace[0];

                        let callingFilename = callingFunctionDetails.file ;
                        let callingFunctionName = callingFunctionDetails.function ;
                        let callingFunctionLine = callingFunctionDetails.line ;

                        if ( callingFunctionDetails.function === 'checkRights' )
                        {
                            // If we were called from checkRights, the actual culprit is the next level down
                            callingFunctionDetails = stackTrace[1] ;
                            callingFunctionName = callingFunctionDetails.function ;
                        }

                        displayMessage = "<p>Error File: " + callingFilename + '</p>';
                        displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                        displayMessage += '<p><b>Authorisation Failed</b></p>';
                    }
                    else if ( type.includes ( '\\APIParameterException'))
                    {
                        // We need to inspect the stack to see where the error actually occurred

                        let detail = getErrorDetailromResponse(data) ;

                        const callingFunctionDetails = stackTrace[0];

                        let callingFilename = detail.file ;
                        let callingFunctionName = callingFunctionDetails.function ;
                        let callingFunctionLine = detail.line ;

                        displayMessage = "<p>Error File: " + callingFilename + '</p>';
                        displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                        displayMessage += '<p><b>Invalid parameters passed to API</b></p>';
                    }
                    else if ( type.includes ( 'ParseError'))
                    {
                        // We need to inspect the stack to see where the error actually occurred

                        const dtail = getErrorDetailromResponse(data) ;

                        const cfDetails = stackTrace[0];

                        const callingFilename = dtail.file ;
                        const callingFunctionName = cfDetails.function ;
                        const callingFunctionLine = dtail.line ;
                        const errorMessage = dtail.message ;

                        displayMessage = "<p>Error File: " + callingFilename + '</p>';
                        displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                        displayMessage += '<p><b>' + errorMessage + '</b></p>';
                    }
                    else if ( type.includes ( '\\PostmarkException'))
                    {
                        // We need to inspect the stack to see where the error actually occurred

                        const pmdetail = getErrorDetailromResponse(data) ;

                        const pmcallingFunctionDetails = stackTrace[3];

                        const callingFilename = pmdetail.file ;
                        const callingFunctionName = pmcallingFunctionDetails.function ;
                        const callingFunctionLine = pmdetail.line ;
                        const errorMessage = pmdetail.message ;

                        displayMessage = "<p>Error File: " + callingFilename + '</p>';
                        displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                        displayMessage += "<p style='color: var(--s360-icon-blue); font-style: italic ;'>" + errorMessage + '</p>';
                        displayMessage += '<p><b>Error sending email</b></p>';
                    }
                    else if ( type.includes ( '\\HttpNotFoundException'))
                    {
                        // We need to inspect the stack to see where the error actually occurred

                        const detail = getErrorDetailromResponse(data) ;

                        const callingFunctionDetails = stackTrace[0];

                        let callingFilename = detail.file ;
                        let callingFunctionName = callingFunctionDetails.function ;
                        let callingFunctionLine = detail.line ;

                        displayMessage = "<p>Error File: " + callingFilename + '</p>';
                        displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                        displayMessage += '<p><b>API Not Found</b></p>';
                    }
                    else if ( type.includes ( 'PDOException'))
                    {
                        // We need to inspect the stack to see where the error actually occurred

                        let pdoDetail = getErrorDetailromResponse(data) ;

                        let callingFunctionDetails = stackTrace[1];

                        if ( callingFunctionDetails.function === 'bindAndExecute')
                        {
                            callingFunctionDetails = stackTrace[2] ;
                        }

                        const callingFilename = pdoDetail.file ;
                        const callingFunctionName = callingFunctionDetails.function ;
                        const callingFunctionLine = pdoDetail.line ;
                        const message = pdoDetail.message ;

                        displayMessage = "<p>Error File: " + callingFilename + '</p>';
                        displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                        displayMessage += '<p><b>' + message + '</b></p>';
                    }
                    else if ( type === 'Error' || type === 'TypeError' )
                    {
                        // We need to inspect the stack to see where the error actually occurred

                        let detail = getErrorDetailromResponse(data) ;

                        let callingFunctionDetails = stackTrace[0];

                        let callingFilename = detail.file ;
                        let callingFunctionName = callingFunctionDetails.function ;
                        let callingFunctionLine = detail.line ;

                        displayMessage = "<p>Error File: " + callingFilename + '</p>';
                        displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                        displayMessage += '<p><b>' + detail.message + '</b></p>';
                    }
                    else if ( type === 'Exception' || type === "RuntimeException")
                    {
                        // We need to inspect the stack to see where the error actually occurred

                        const exd = getErrorDetailromResponse(data) ;

                        let excfd = stackTrace[0];

                        let callingFilename = exd.file ;
                        let callingFunctionName = excfd.function ;
                        let callingFunctionLine = exd.line ;

                        displayMessage = "<p>Error File: " + callingFilename + '</p>';
                        displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                        displayMessage += '<p><b>' + exd.message + '</b></p>';
                    }
                }
                else if (getErrorFromResponse(data) === "PDO Exception")
                {
                    const details = getErrorDetailFromResponse(data);

                    displayMessage = "<p>Error File: " + details.file + '</p>';
                    displayMessage += "<p>Error Line: " + details.line + '</p>';
                    displayMessage += '<p>' + details.message + '</p>';
                }
                else if (getErrorFromResponse(data) === "Exception")
                {
                    const details = getErrorDetailFromResponse(data);

                    displayMessage = "<p>Error File: " + details.file + '</p>';
                    displayMessage += "<p>Error Line: " + details.line + '</p>';
                    displayMessage += '<p>' + details.message + '</p>';
                }
                else if (getErrorFromResponse(data) === "Invaild JWT Token")
                {
                    var emailContact = '<a href="mailto:info@school360.co.uk">info@school360.co.uk</a>'
                    displayMessage = "<p>Invaild Token: Your security token has expired. Please contact the person who invited you to ARCBOX. Or email  " + emailContact + '</p>';
                }
                else
                {
                    displayMessage = "<p>Error: " + data.error + "</p>";
                    displayMessage += "<p>Detail: " + data.errorDetail + "</p>";
                }

                const myModal = new Modal({
                    title: 'The Operation Failed',
                    content: displayMessage
                }).show();
            }
        }
        else
        {
            const regex = /^.*(status).*$/mg;
            const jsonBit = data.match(regex);

            let msg = '';
            let fullMessage = '';

            if (jsonBit === null)
            {
                fullMessage = data;
            }
            else
            {
                const obj = JSON.parse(jsonBit[0]);

                fullMessage = "Error occurred in " + obj.status.errorDetail.file + "<br/>";
                fullMessage += "Line " + obj.status.errorDetail.line + "<br/>";
                fullMessage += "Message " + obj.status.errorDetail.message + "<br/>";
            }

            const myModal = new Modal({
                title: 'The Operation Failed',
                content: fullMessage
            }).show();
        }
    }
    else
    {
        const myModal = new Modal({
            title: 'The Operation Failed',
            content: 'Null Response From Server'
        }).show();
    }

    return false;
}

function getThisErrorObject()
{
    try
    {
        throw Error("");
    }
    catch (err)
    {
        const res = ErrorStackParser.parse(err);

        return res;
    }
}

export const handleAjaxError = (jqXHR, exception, error, returnUrl) =>
{
    let msg = '';
    let fullMessage = '';

    console.error(jqXHR);

    if (jqXHR.constructor === TypeError || jqXHR.constructor === ReferenceError || jqXHR.constructor === Error)
    {
        msg = "Error";
        fullMessage = jqXHR.message + '<br><br>' + jqXHR.fileName + "<br><br>" + jqXHR.lineNumber + "<br><br>" + jqXHR.stack;
    }
    else
    {
        if (jqXHR.status === 0 || jqXHR.readyState === 0)
        {
            return;
        }
        ;

        if (exception === 'parsererror')
        {
            const regex = /^.*(status).*$/mg;
            const jsonBit = jqXHR.responseText.match(regex);

            const obj = JSON.parse(jsonBit[0]);

            msg = obj.status.error;
            fullMessage = "Error occurred in " + obj.status.errorDetail.file + "<br/>";
            fullMessage += "Line " + obj.status.errorDetail.line + "<br/>";
            fullMessage += "Message " + obj.status.errorDetail.message + "<br/>";
        }
        else if (jqXHR.status === 0)
        {
            msg = 'Not connected.\n Verify Network.';
        }
        else if (jqXHR.status == 404)
        {
            if (jqXHR.responseJSON != null)
            {
                const status = jqXHR.responseJSON;

                if (status.error == "Exception")
                {
                    fullMessage = "<p>Error URL: " + status.errorDetail.file + '</p>';
                    fullMessage += '<p>' + status.errorDetail.message + '</p>';
                }
            }
            else
            {
                msg = 'Page Not Found. [404]' + '</p>';
            }
        }
        else if (jqXHR.status == 400)
        {
            msg = 'Bad Parameters. [400]' + '</p>';

            if (jqXHR.responseJSON != null)
            {
                const status = jqXHR.responseJSON;

                if (status.error == "Exception")
                {
                    fullMessage = "<p>Error File: " + status.errorDetail.file + '</p>';
                    fullMessage += "<p>Error Line: " + status.errorDetail.line + '</p>';
                    fullMessage += '<p>' + status.errorDetail.message + '</p>';
                }
            }

        }
        else if (jqXHR.status == 401)
        {
            msg = 'Not Authorised. [404]';
        }
        else if (jqXHR.status == 500)
        {
            msg = 'Internal Server Error [500].';

            if (jqXHR.responseJSON != null)
            {
                const status = jqXHR.responseJSON;

                if (status.error === "Exception")
                {
                    fullMessage = "<p>Error File: " + status.errorDetail.file + '</p>';
                    fullMessage += "<p>Error Line: " + status.errorDetail.line + '</p>';
                    fullMessage += '<p>' + status.errorDetail.message + '</p>';
                }
            }

        }
        else if (exception === 'parsererror')
        {
            msg = 'Requested JSON parse failed.';
        }
        else if (exception === 'timeout')
        {
            msg = 'Time out error.';
        }
        else if (exception === 'abort')
        {
            msg = 'Ajax request aborted.';
        }
        else
        {
            msg = 'Uncaught Error.\n' + jqXHR.responseText;
        }

        const stackFrames = getThisErrorObject();

        const callingFrame = stackFrames[2];

        if (fullMessage == '')
        {
            fullMessage = "Error occurred in function " + callingFrame.functionName + " in module " + callingFrame.fileName + " at line " + callingFrame.lineNumber;
        }

        //fullMessage = error.stack + jqXHR.responseText + '<br><br>' + stackFrames ;

        if (jqXHR.status == 401)
        {
            fullMessage = "You are not authorised to perform this operation."
        }
    }

    const myModal = new Modal({
        title: 'The Operation Failed - ' + msg,
        content: fullMessage
    }).show();
}

export const Globals = (function ()
{
    const APIFolder = '/api/v1.0';

    function Globals()
    {
    }

    Object.defineProperty(Globals, "APIFolder", {
        get: function () {
            return 'https://' + document.location.hostname + APIFolder;
        },
    });

    Object.defineProperty(Globals, "School360APIFolder", {
        get: function () {
            return 'https://' + 'school360.pc' + APIFolder;
        },
    });

    Object.defineProperty(Globals, "BaseURL", {
        get: function () {
            return 'https://' + document.location.hostname;
        },
    });

    return Globals;
})();

export const toCapitalised = (word) => {
    const firstLetter = word.charAt(0);
    const firstLetterCap = firstLetter.toUpperCase();
    const remainingLetters = word.slice(1);
    return firstLetterCap + remainingLetters;
}


